// Author thq
// Date 2022-04-20 11:43:54

class ImfEmSicEqStatusMoniRecoIesmr {
constructor({
        id = null,
        iesmrIdIesmrs = '',
        iesmrSidBda = '',
        iesmrCodeBda = '',
        iesmrBeginTime = '',
        iesmrEndTime = '',
        iesmrManually = '',
        iesmrEnable = '',
        iesmrIdDept = '',
        iesmrIdDeptName = '',
        iesmrIdImfloc = '',
        iesmrIdIesmrr = '',
        iesmrReason = '',
        iesmrAttachment = '',
        iesmrRecorder = '',
        iesmrRecorderRealName = '',
        remark = '',
        iesmrAttachmentList = ''}
= {}) {
    this.id = id;
    this.iesmrIdIesmrs = iesmrIdIesmrs;
    this.iesmrSidBda = iesmrSidBda;
    this.iesmrCodeBda = iesmrCodeBda;
    this.iesmrBeginTime = iesmrBeginTime;
    this.iesmrEndTime = iesmrEndTime;
    this.iesmrManually = iesmrManually;
    this.iesmrEnable = iesmrEnable;
    this.iesmrIdDept = iesmrIdDept;
    this.iesmrIdDeptName = iesmrIdDeptName;
    this.iesmrIdImfloc = iesmrIdImfloc;
    this.iesmrIdIesmrr = iesmrIdIesmrr;
    this.iesmrReason = iesmrReason;
    this.iesmrAttachment = iesmrAttachment;
    this.iesmrRecorder = iesmrRecorder;
    this.iesmrRecorderRealName = iesmrRecorderRealName;
    this.remark = remark;
    this.iesmrAttachmentList = iesmrAttachmentList;
}
}

function newEntity() {
return new ImfEmSicEqStatusMoniRecoIesmr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrIdIesmrs',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrIdIesmrs',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrs',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrs',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrSidBda',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrSidBda',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrCodeBda',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrCodeBda',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emArchBdaName',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.emArchBdaName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrBeginTime',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrEndTime',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrManually',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrManually',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrEnable',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrEnable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrIdDept',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrIdDept',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrIdIesmrr',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrIdIesmrr',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrrName',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrrName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrReason',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrReason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrAttachmentList',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrRecorderRealName',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrRecorderRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrIdImfloc',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrIdImfloc',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'iesmrNameImfloc',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.grid.iesmrNameImfloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    iesmrIdIesmrsFilter : '',
    iesmrsIdInFilter : [],
    iesmrsNodeCodeStartWithFilter : '',
    iesmrSidBdaFilter : '',
    iesmrCodeBdaFilter : '',
    bdaNameFilter : '',
    iesmrBeginTimeRteFilter : '',
    iesmrBeginTimeLteFilter : '',
    iesmrEndTimeRteFilter : '',
    iesmrEndTimeLteFilter : '',
    iesmrEndTimeIsNullFilter : '',
    iesmrManuallyFilter : '',
    iesmrEnableFilter : '',
    iesmrIdDeptFilter : '',
    iesmrIdIesmrrFilter : '',
    iesmrIdIesmrrInFilter : [],
    iesmrrNodeCodeStartWithFilter : '',
    iesmrReasonFilter : '',
    iesmrRecorderFilter : '',
    iesmrRecorderRealNameFilter : '',
    emAclDeptIdFilter : '',
    emAclDeptNameFilter : '',
    emAclDeptNodeCodeFilter : '',
    emAclDeptNodeCodeNameFilter : '',
    iesmrIdImflocFilter : '',
    iesmrNameImflocFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'iesmrsIdInFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrsIdIn',
        disabled: false,
        form: {
        type: 'treeSelectMultiple',
        modalMultiSelectedType: 'list'
            ,entity: 'imfEmSicIesmrStatusIesmrs'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'iesmrSidBdaFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrSidBda',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrCodeBdaFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrCodeBda',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bdaNameFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.bdaName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrBeginTimeRteFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrBeginTimeLteFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrEndTimeRteFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrEndTimeLteFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrEndTimeIsNullFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrEndTimeIsNull',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrManuallyFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrManually',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrEnableFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrEnable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrIdIesmrrInFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrIdIesmrrIn',
        disabled: false,
        form: {
        type: 'treeSelectMultiple',
        modalMultiSelectedType: 'list'
            ,entity: 'imfEmSicIesmrReasonIesmrr'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'iesmrReasonFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrReason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrRecorderRealNameFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrRecorderRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'iesmrNameImflocFilter',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.filter.iesmrNameImfloc',
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"iesmrIdImfloc":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'iesmrIdIesmrs',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrIdIesmrs',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrStatusIesmrs'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'iesmrCodeBda',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"iesmrSidBda":"sid"}'
                }
        },
        {
        key: 'iesmrBeginTime',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrEndTime',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrEnable',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrIdDeptName',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrIdDeptName',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"iesmrIdDept":"id"}'
                }
        },
        {
        key: 'iesmrIdImfloc',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrIdImfloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'iesmrIdIesmrr',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrIdIesmrr',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrReasonIesmrr'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'iesmrReason',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrRecorderRealName',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrRecorderRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"iesmrRecorder":"loginName"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'iesmrAttachmentList',
        label: 'label.em.statusCollection.imfEmSicEqStatusMoniRecoIesmr.entity.iesmrAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'iesmrAttachment'
                }
        }
]

export {ImfEmSicEqStatusMoniRecoIesmr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
